const API_BASE_URL = 'http://localhost:5000/api';

export const testDatabaseConnection = async () => {
  try {
    const response = await fetch(`${API_BASE_URL}/test`);
    const data = await response.json();
    return data;
  } catch (error) {
    console.error('Error testing database connection:', error);
    throw error;
  }
};

// CLIENTS CRUD
export const fetchClients = async () => {
  const response = await fetch(`${API_BASE_URL}/clients`);
  if (!response.ok) throw new Error('Failed to fetch clients');
  return response.json();
};

export const createClient = async (client) => {
  const response = await fetch(`${API_BASE_URL}/clients`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(client),
  });
  if (!response.ok) throw new Error('Failed to create client');
  return response.json();
};

export const updateClient = async (id, client) => {
  const response = await fetch(`${API_BASE_URL}/clients/${id}`, {
    method: 'PUT',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(client),
  });
  if (!response.ok) throw new Error('Failed to update client');
  return response.json();
};

export const deleteClient = async (id) => {
  const response = await fetch(`${API_BASE_URL}/clients/${id}`, {
    method: 'DELETE'
  });
  if (!response.ok) throw new Error('Failed to delete client');
  return response.json();
};

export const fetchClientById = async (id) => {
  const response = await fetch(`${API_BASE_URL}/clients/${id}`);
  if (!response.ok) throw new Error('Failed to fetch client');
  return response.json();
};

// TASKS CRUD
export const fetchTasks = async () => {
  const response = await fetch(`${API_BASE_URL}/tasks`);
  if (!response.ok) throw new Error('Failed to fetch tasks');
  return response.json();
};

export const createTask = async (task) => {
  const response = await fetch(`${API_BASE_URL}/tasks`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(task),
  });
  if (!response.ok) throw new Error('Failed to create task');
  return response.json();
};

export const updateTask = async (id, task) => {
  const response = await fetch(`${API_BASE_URL}/tasks/${id}`, {
    method: 'PUT',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(task),
  });
  if (!response.ok) throw new Error('Failed to update task');
  return response.json();
};

export const deleteTask = async (id) => {
  const response = await fetch(`${API_BASE_URL}/tasks/${id}`, {
    method: 'DELETE'
  });
  if (!response.ok) throw new Error('Failed to delete task');
  return response.json();
};

export const fetchTaskById = async (id) => {
  const response = await fetch(`${API_BASE_URL}/tasks/${id}`);
  if (!response.ok) throw new Error('Failed to fetch task');
  return response.json();
};

// PROCESSES CRUD
export const fetchProcesses = async () => {
  const response = await fetch(`${API_BASE_URL}/processes`);
  if (!response.ok) throw new Error('Failed to fetch processes');
  return response.json();
};

export const createProcess = async (process) => {
  const response = await fetch(`${API_BASE_URL}/processes`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(process),
  });
  if (!response.ok) throw new Error('Failed to create process');
  return response.json();
};

export const updateProcess = async (id, process) => {
  const response = await fetch(`${API_BASE_URL}/processes/${id}`, {
    method: 'PUT',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(process),
  });
  if (!response.ok) throw new Error('Failed to update process');
  return response.json();
};

export const deleteProcess = async (id) => {
  const response = await fetch(`${API_BASE_URL}/processes/${id}`, {
    method: 'DELETE'
  });
  if (!response.ok) throw new Error('Failed to delete process');
  return response.json();
};

export const fetchProcessById = async (id) => {
  const response = await fetch(`${API_BASE_URL}/processes/${id}`);
  if (!response.ok) throw new Error('Failed to fetch process');
  return response.json();
};

// PHASES CRUD
export const fetchPhases = async () => {
  const response = await fetch(`${API_BASE_URL}/phases`);
  if (!response.ok) throw new Error('Failed to fetch phases');
  return response.json();
};

export const createPhase = async (phase) => {
  const response = await fetch(`${API_BASE_URL}/phases`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(phase),
  });
  if (!response.ok) throw new Error('Failed to create phase');
  return response.json();
};

export const updatePhase = async (id, phase) => {
  const response = await fetch(`${API_BASE_URL}/phases/${id}`, {
    method: 'PUT',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(phase),
  });
  if (!response.ok) throw new Error('Failed to update phase');
  return response.json();
};

export const deletePhase = async (id) => {
  const response = await fetch(`${API_BASE_URL}/phases/${id}`, {
    method: 'DELETE'
  });
  if (!response.ok) throw new Error('Failed to delete phase');
  return response.json();
};

export const fetchPhaseById = async (id) => {
  const response = await fetch(`${API_BASE_URL}/phases/${id}`);
  if (!response.ok) throw new Error('Failed to fetch phase');
  return response.json();
};

// LOCATIONS CRUD
export const fetchLocations = async () => {
  const response = await fetch(`${API_BASE_URL}/locations`);
  if (!response.ok) throw new Error('Failed to fetch locations');
  return response.json();
};

export const createLocation = async (location) => {
  const response = await fetch(`${API_BASE_URL}/locations`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(location),
  });
  if (!response.ok) throw new Error('Failed to create location');
  return response.json();
};

export const updateLocation = async (id, location) => {
  const response = await fetch(`${API_BASE_URL}/locations/${id}`, {
    method: 'PUT',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(location),
  });
  if (!response.ok) throw new Error('Failed to update location');
  return response.json();
};

export const deleteLocation = async (id) => {
  const response = await fetch(`${API_BASE_URL}/locations/${id}`, {
    method: 'DELETE'
  });
  if (!response.ok) throw new Error('Failed to delete location');
  return response.json();
};

// EMPLOYEE ENGAGEMENTS CRUD
export const fetchEmployeeEngagements = async () => {
  const response = await fetch(`${API_BASE_URL}/employee-engagements`);
  if (!response.ok) throw new Error('Failed to fetch employee engagements');
  return response.json();
};

export const createEmployeeEngagement = async (engagement) => {
  const response = await fetch(`${API_BASE_URL}/employee-engagements`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(engagement),
  });
  if (!response.ok) throw new Error('Failed to create employee engagement');
  return response.json();
};

export const updateEmployeeEngagement = async (id, engagement) => {
  const response = await fetch(`${API_BASE_URL}/employee-engagements/${id}`, {
    method: 'PUT',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(engagement),
  });
  if (!response.ok) throw new Error('Failed to update employee engagement');
  return response.json();
};

export const deleteEmployeeEngagement = async (id) => {
  const response = await fetch(`${API_BASE_URL}/employee-engagements/${id}`, {
    method: 'DELETE'
  });
  if (!response.ok) throw new Error('Failed to delete employee engagement');
  return response.json();
};

// RESOURCE MAPPINGS CRUD
export const fetchResourceMappings = async () => {
  const response = await fetch(`${API_BASE_URL}/resource-mappings`);
  if (!response.ok) throw new Error('Failed to fetch resource mappings');
  return response.json();
};

export const createResourceMapping = async (mapping) => {
  const response = await fetch(`${API_BASE_URL}/resource-mappings`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(mapping),
  });
  if (!response.ok) throw new Error('Failed to create resource mapping');
  return response.json();
};

export const updateResourceMapping = async (id, mapping) => {
  const response = await fetch(`${API_BASE_URL}/resource-mappings/${id}`, {
    method: 'PUT',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(mapping),
  });
  if (!response.ok) throw new Error('Failed to update resource mapping');
  return response.json();
};

export const deleteResourceMapping = async (id) => {
  const response = await fetch(`${API_BASE_URL}/resource-mappings/${id}`, {
    method: 'DELETE'
  });
  if (!response.ok) throw new Error('Failed to delete resource mapping');
  return response.json();
};

// PROJECT TIMELINES CRUD
export const fetchProjectTimelines = async () => {
  const response = await fetch(`${API_BASE_URL}/project-timelines`);
  if (!response.ok) throw new Error('Failed to fetch project timelines');
  return response.json();
};

export const createProjectTimeline = async (timeline) => {
  const response = await fetch(`${API_BASE_URL}/project-timelines`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(timeline),
  });
  if (!response.ok) throw new Error('Failed to create project timeline');
  return response.json();
};

export const updateProjectTimeline = async (id, timeline) => {
  const response = await fetch(`${API_BASE_URL}/project-timelines/${id}`, {
    method: 'PUT',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(timeline),
  });
  if (!response.ok) throw new Error('Failed to update project timeline');
  return response.json();
};

export const deleteProjectTimeline = async (id) => {
  const response = await fetch(`${API_BASE_URL}/project-timelines/${id}`, {
    method: 'DELETE'
  });
  if (!response.ok) throw new Error('Failed to delete project timeline');
  return response.json();
};

export const createProject = async (project) => {
  const response = await fetch(`${API_BASE_URL}/projects`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(project),
  });
  if (!response.ok) throw new Error('Failed to create project');
  return response.json();
};

export const fetchProjects = async () => {
  const response = await fetch(`${API_BASE_URL}/projects`);
  if (!response.ok) throw new Error('Failed to fetch projects');
  return response.json();
};

export const fetchProjectById = async (id) => {
  const response = await fetch(`${API_BASE_URL}/projects/${id}`);
  if (!response.ok) throw new Error('Failed to fetch project');
  return response.json();
};

export const updateProject = async (id, project) => {
  const response = await fetch(`${API_BASE_URL}/projects/${id}`, {
    method: 'PUT',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(project),
  });
  if (!response.ok) throw new Error('Failed to update project');
  return response.json();
};

export const deleteProject = async (id) => {
  const response = await fetch(`${API_BASE_URL}/projects/${id}`, {
    method: 'DELETE'
  });
  if (!response.ok) throw new Error('Failed to delete project');
  return response.json();
};

// PROJECT TIMELINE ASSIGNMENTS CRUD
export const fetchProjectTimelineAssignments = async () => {
  const response = await fetch(`${API_BASE_URL}/project-timeline-assignments`);
  if (!response.ok) throw new Error('Failed to fetch project timeline assignments');
  return response.json();
};

export const createProjectTimelineAssignment = async (assignment) => {
  const response = await fetch(`${API_BASE_URL}/project-timeline-assignments`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(assignment),
  });
  if (!response.ok) throw new Error('Failed to create project timeline assignment');
  return response.json();
};

export const updateProjectTimelineAssignment = async (id, assignment) => {
  const response = await fetch(`${API_BASE_URL}/project-timeline-assignments/${id}`, {
    method: 'PUT',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(assignment),
  });
  if (!response.ok) throw new Error('Failed to update project timeline assignment');
  return response.json();
};

export const deleteProjectTimelineAssignment = async (id) => {
  const response = await fetch(`${API_BASE_URL}/project-timeline-assignments/${id}`, {
    method: 'DELETE'
  });
  if (!response.ok) throw new Error('Failed to delete project timeline assignment');
  return response.json();
};

// Get projects by client ID
export const fetchProjectsByClient = async (clientId) => {
  const response = await fetch(`${API_BASE_URL}/projects/by-client/${clientId}`);
  if (!response.ok) throw new Error('Failed to fetch projects by client');
  return response.json();
};

// Get processes by client ID
export const fetchProcessesByClient = async (clientId) => {
  const response = await fetch(`${API_BASE_URL}/processes/by-client/${clientId}`);
  if (!response.ok) throw new Error('Failed to fetch processes by client');
  return response.json();
};

// LEVELS CRUD
export const fetchLevels = async () => {
  const response = await fetch(`${API_BASE_URL}/levels`);
  if (!response.ok) throw new Error('Failed to fetch levels');
  return response.json();
};

export const fetchLevelById = async (id) => {
  const response = await fetch(`${API_BASE_URL}/levels/${id}`);
  if (!response.ok) throw new Error('Failed to fetch level');
  return response.json();
};

export const createLevel = async (level) => {
  const response = await fetch(`${API_BASE_URL}/levels`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(level),
  });
  if (!response.ok) throw new Error('Failed to create level');
  return response.json();
};

export const updateLevel = async (id, level) => {
  const response = await fetch(`${API_BASE_URL}/levels/${id}`, {
    method: 'PUT',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(level),
  });
  if (!response.ok) throw new Error('Failed to update level');
  return response.json();
};

export const deleteLevel = async (id) => {
  const response = await fetch(`${API_BASE_URL}/levels/${id}`, {
    method: 'DELETE',
  });
  if (!response.ok) throw new Error('Failed to delete level');
  return response.json();
};

// DEPARTMENTS CRUD
export const fetchDepartments = async () => {
  const response = await fetch(`${API_BASE_URL}/departments`);
  if (!response.ok) throw new Error('Failed to fetch departments');
  return response.json();
};

export const createDepartment = async (department) => {
  const response = await fetch(`${API_BASE_URL}/departments`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(department),
  });
  if (!response.ok) throw new Error((await response.json()).error || 'Failed to create department');
  return response.json();
};

export const updateDepartment = async (id, department) => {
  const response = await fetch(`${API_BASE_URL}/departments/${id}`, {
    method: 'PUT',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(department),
  });
  if (!response.ok) throw new Error((await response.json()).error || 'Failed to update department');
  return response.json();
};

export const deleteDepartment = async (id) => {
  const response = await fetch(`${API_BASE_URL}/departments/${id}`, {
    method: 'DELETE',
  });
  if (!response.ok) throw new Error('Failed to delete department');
  return response.json();
};

// EMPLOYEE TYPES
export const fetchEmployeeTypes = async () => {
  const response = await fetch(`${API_BASE_URL}/employee-types`);
  if (!response.ok) throw new Error('Failed to fetch employee types');
  return response.json();
};

// USER ROLES
export const fetchUserRoles = async () => {
  const response = await fetch(`${API_BASE_URL}/user-roles`);
  if (!response.ok) throw new Error('Failed to fetch user roles');
  return response.json();
};

// USERS CRUD
export const fetchUsers = async () => {
  const response = await fetch(`${API_BASE_URL}/users`);
  if (!response.ok) throw new Error('Failed to fetch users');
  return response.json();
};

export const createUser = async (user) => {
  const response = await fetch(`${API_BASE_URL}/users`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(user),
  });
  if (!response.ok) throw new Error((await response.json()).error || 'Failed to create user');
  return response.json();
};

export const updateUser = async (id, user) => {
  const response = await fetch(`${API_BASE_URL}/users/${id}`, {
    method: 'PUT',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(user),
  });
  if (!response.ok) throw new Error((await response.json()).error || 'Failed to update user');
  return response.json();
};

export const deleteUser = async (id) => {
  const response = await fetch(`${API_BASE_URL}/users/${id}`, {
    method: 'DELETE',
  });
  if (!response.ok) throw new Error('Failed to delete user');
  return response.json();
};

export const editProfile = async (id, profile) => {
  const response = await fetch(`${API_BASE_URL}/users/profile/${id}`, {
    method: 'PUT',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(profile),
  });
  if (!response.ok) throw new Error('Failed to update profile');
  return response.json();
};

export const adminResetPassword = async (id, password) => {
  const response = await fetch(`${API_BASE_URL}/users/reset-password/${id}`, {
    method: 'PUT',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ password }),
  });
  if (!response.ok) throw new Error('Failed to reset password');
  return response.json();
};

// Employee-Manager Mapping APIs
export const fetchEmployeeManagerMappings = async () => {
  const response = await fetch(`${API_BASE_URL}/employee-manager-mappings`);
  if (!response.ok) throw new Error('Failed to fetch mappings');
  return response.json();
};

export const fetchUnmappedEmployees = async () => {
  const response = await fetch(`${API_BASE_URL}/unmapped-employees`);
  if (!response.ok) throw new Error('Failed to fetch unmapped employees');
  return response.json();
};

export const createEmployeeManagerMapping = async (employee_id, manager_id) => {
  const response = await fetch(`${API_BASE_URL}/employee-manager-mappings`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ employee_id, manager_id })
  });
  return response.json();
};

export const releaseEmployeeManagerMapping = async (id) => {
  const response = await fetch(`${API_BASE_URL}/employee-manager-mappings/${id}`, { method: 'DELETE' });
  return response.json();
};

export const replaceEmployeeInMapping = async (id, new_employee_id) => {
  const response = await fetch(`${API_BASE_URL}/employee-manager-mappings/${id}/replace`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ new_employee_id })
  });
  return response.json();
};

export const fetchOrgTree = async () => {
  const response = await fetch(`${API_BASE_URL}/org-tree`);
  if (!response.ok) throw new Error('Failed to fetch org tree');
  return response.json();
};

// EMAIL CONFIGURATION APIs
export const fetchEmailTemplates = async () => {
  const response = await fetch(`${API_BASE_URL}/email-templates`);
  if (!response.ok) throw new Error('Failed to fetch email templates');
  return response.json();
};

export const createEmailTemplate = async (template) => {
  const response = await fetch(`${API_BASE_URL}/email-templates`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(template),
  });
  if (!response.ok) throw new Error('Failed to create email template');
  return response.json();
};

export const updateEmailTemplate = async (id, template) => {
  const response = await fetch(`${API_BASE_URL}/email-templates/${id}`, {
    method: 'PUT',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(template),
  });
  if (!response.ok) throw new Error('Failed to update email template');
  return response.json();
};

export const deleteEmailTemplate = async (id) => {
  const response = await fetch(`${API_BASE_URL}/email-templates/${id}`, {
    method: 'DELETE',
  });
  if (!response.ok) throw new Error('Failed to delete email template');
  return response.json();
};

export const fetchSmtpSettings = async () => {
  const response = await fetch(`${API_BASE_URL}/smtp-settings`);
  if (!response.ok) throw new Error('Failed to fetch SMTP settings');
  return response.json();
};

export const saveSmtpSettings = async (settings) => {
  const response = await fetch(`${API_BASE_URL}/smtp-settings`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(settings),
  });
  if (!response.ok) throw new Error('Failed to save SMTP settings');
  return response.json();
};

export const testSmtpConnection = async (settings) => {
  const response = await fetch(`${API_BASE_URL}/smtp-test`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(settings),
  });
  if (!response.ok) throw new Error('Failed to test SMTP connection');
  return response.json();
};

export const fetchEmailLogs = async () => {
  const response = await fetch(`${API_BASE_URL}/email-logs`);
  if (!response.ok) throw new Error('Failed to fetch email logs');
  return response.json();
};

export const sendEmail = async (emailData) => {
  const response = await fetch(`${API_BASE_URL}/send-email`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(emailData),
  });
  if (!response.ok) throw new Error('Failed to send email');
  return response.json();
};

// Create an api object for backward compatibility
const api = {
  get: async (endpoint) => {
    const response = await fetch(`${API_BASE_URL}${endpoint}`);
    if (!response.ok) throw new Error(`GET ${endpoint} failed`);
    return response.json();
  },
  post: async (endpoint, data) => {
    const response = await fetch(`${API_BASE_URL}${endpoint}`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(data),
    });
    if (!response.ok) throw new Error(`POST ${endpoint} failed`);
    return response.json();
  },
  put: async (endpoint, data) => {
    const response = await fetch(`${API_BASE_URL}${endpoint}`, {
      method: 'PUT',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(data),
    });
    if (!response.ok) throw new Error(`PUT ${endpoint} failed`);
    return response.json();
  },
  delete: async (endpoint) => {
    const response = await fetch(`${API_BASE_URL}${endpoint}`, {
      method: 'DELETE',
    });
    if (!response.ok) throw new Error(`DELETE ${endpoint} failed`);
    return response.json();
  },
};

export { api };

export const fetchDottedReportees = async (userId) => {
  const response = await fetch(`${API_BASE_URL}/users/${userId}/dotted-reportees`);
  if (!response.ok) throw new Error('Failed to fetch dotted-line reportees');
  return response.json();
};

export const setDottedReportees = async (userId, dottedIds) => {
  const response = await fetch(`${API_BASE_URL}/users/${userId}/dotted-reportees`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ dotted_reportee_ids: dottedIds })
  });
  if (!response.ok) throw new Error('Failed to set dotted-line reportees');
  return response.json();
};

export const deleteDottedReportee = async (userId, dottedId) => {
  const response = await fetch(`${API_BASE_URL}/users/${userId}/dotted-reportees/${dottedId}`, {
    method: 'DELETE'
  });
  if (!response.ok) throw new Error('Failed to delete dotted-line reportee');
  return response.json();
};